<template>
  <div class="flex items-center justify-between h-10 px-3 py-2 transition-color duration-150">
    <span>{{ item }}</span>
    <span v-if="selected" :class="variant">
      <CheckIcon class="w-6" />
    </span>
  </div>
</template>

<script lang="ts" setup>
import { CheckIcon } from '@heroicons/vue/24/outline'

defineProps({
  item: {
    type: String,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: 'copper',
  },
})
</script>

<style lang="stylus" scoped>
.copper
  @apply text-copper-700

.white
  color white
</style>
